import {KeyValue} from "./keyValue";

/**
 * This represents a selectable item in the option menu.
 */
export class OptionMenuKeyValue extends KeyValue {
  /**
   * True if this option is considered as a dangerous action.
   */
  isDanger: boolean;

  /**
   * Is this option disabled
   */
  isDisabled: boolean = false;

  constructor(
    value: string,
    label: string,
    isDanger: boolean = false,
    isDisabled?: boolean
  ) {
    super(value, label);
    this.isDanger = isDanger;
    this.isDisabled = !!isDisabled;
  }
}
